import { FC, PropsWithChildren } from 'react';
import { useResetPasswordSendCodeMutation } from '@/transport/gatewayApi';
import { UseDoResetPasswordSendCodeMutationContext } from '@/bo-kit/components/ResetPasswordPage/components/ResetPassword/ResetPasswordForm/hook/useDoResetPasswordSendCode';

export const UseDoResetPasswordSendCodeMutationContextProvider: FC<PropsWithChildren> = ({
    children,
}) => {
    const [doResetPasswordSendCode, state] = useResetPasswordSendCodeMutation();
    return (
        <UseDoResetPasswordSendCodeMutationContext.Provider
            value={[doResetPasswordSendCode, state]}
        >
            {children}
        </UseDoResetPasswordSendCodeMutationContext.Provider>
    );
};
